namespace Nobox {
    export interface DashboardContactPageModel {
        Contact?: number;
        List?: number;
        Tags?: number;
        Tool?: number;
        ArrCreated?: contactGroup[];
        ContactCountry?: { [key: string]: number };
        TopCountries?: Nobox.Common.Pages.contactCountry[];
        TopTools?: Nobox.Common.Pages.contactCountry[];
    }
}
